module.exports = {
    cpf(str){
        if(str && str.length !== 11) return ""
        return str.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4") 
    }
 }